import type { AppLocale } from "./i18n";

export type CircleRitual = "frog" | "tree";

export interface CircleLeader {
  names: Readonly<Record<AppLocale, string>>;
  ritualCount: number;
}

export interface SampleCircleSnapshot {
  label: "Fictional demo circle";
  peopleCount: number;
  leaders: readonly CircleLeader[];
}

export const SAMPLE_CIRCLES: Readonly<Record<CircleRitual, SampleCircleSnapshot>> = {
  frog: {
    label: "Fictional demo circle",
    peopleCount: 286,
    leaders: [
      { names: { en: "Maya M.", uk: "Олена К." }, ritualCount: 18 },
      { names: { en: "Leo K.", uk: "Максим Л." }, ritualCount: 15 },
      { names: { en: "Nia R.", uk: "Софія Р." }, ritualCount: 13 },
      { names: { en: "Sam P.", uk: "Андрій П." }, ritualCount: 11 },
      { names: { en: "Jules T.", uk: "Юлія Т." }, ritualCount: 9 },
    ],
  },
  tree: {
    label: "Fictional demo circle",
    peopleCount: 341,
    leaders: [
      { names: { en: "Amara L.", uk: "Марія Л." }, ritualCount: 21 },
      { names: { en: "Theo B.", uk: "Дмитро Б." }, ritualCount: 17 },
      { names: { en: "Mina K.", uk: "Катерина К." }, ritualCount: 14 },
      { names: { en: "Ari C.", uk: "Артем С." }, ritualCount: 12 },
      { names: { en: "Noor S.", uk: "Ірина Н." }, ritualCount: 10 },
    ],
  },
};
